export default "__VITE_ASSET__f6ef2c69__"